import { render, staticRenderFns } from "./DateInputBehaviorEditor.vue?vue&type=template&id=099614da&"
import script from "./DateInputBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./DateInputBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports